// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { Pie } from "react-chartjs-2";

const PieChartOptions = {
  maintainAspectRatio: false,
  title: {
    display: false,
    text: "Disability Breakdown"
  },
  legend: {
    onClick: null
  },
  tooltips: {
    //displayColors: false,
    callbacks: {
      title: function(tooltipItem){
        return this._data.labels[tooltipItem[0].index]
      },
      label: function(tooltipItem){
        let value = this._data.datasets[0].data[tooltipItem.index]
        let percentage = value / 319;
        let percentString = percentage.toLocaleString('en-US', {
          style: 'percent',
          maximumFractionDigits: 0,
        });
        let valString = value + ' students';
        return valString +', ' +  percentString
      }
    }
  }
};

interface DisabilityBreakdownProps{
  caption: Array<string>;
}

class DisabilityBreakdownPieChartCard extends React.Component<DisabilityBreakdownProps> {
  constructor(props: DisabilityBreakdownProps){
    super(props);
  }
  state = {
    //using this as the data
    //hardcoded this year bc we couldn't make google sheets work
    type: "pie",
    labels: ["Has a disability", "Does not have a disability", "Prefer not to say"],
    datasets: [
      {
        data: [12, 192, 12],
        backgroundColor: ["#48A2D3", "#F0A202", "#E84855"],
      },
    ]
  };
  render() {
    const caption = this.props.caption
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Staff disability breakdown
        </div>
        <div
          className={css`
            height: 500px;
            width: 100%;
          `}
        >
          <Pie
            data={this.state}
            options={{
              ...PieChartOptions
            }}
          />
        </div>
        <div
          className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: left;
          `}
        >
          {caption}
        </div>
      </Card>
    );
  }
}

export default DisabilityBreakdownPieChartCard;
